import React, { useEffect, useState } from "react";
import { Smartphone, Apple, Monitor, ArrowRight, Download } from "lucide-react";

export default function AppRedirect() {
  const [deviceInfo, setDeviceInfo] = useState({
    type: "detecting", // 'android' | 'ios' | 'desktop'
    name: "Detecting Device...",
  });

  const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.medrpha_labs.app";
  // Apple App Store link (or web fallback if iOS app in review)
  const APP_STORE_URL = "https://apps.apple.com/app/medrph-labs/id6470000000"; 
  const WEB_URL = window.location.origin || "https://medrphalabs.com";

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let detectedType = "desktop";
    let detectedName = "Desktop / PC Browser";
    let targetUrl = WEB_URL;

    // 1. Check iOS (iPhone, iPad, iPod)
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      detectedType = "ios";
      detectedName = "Apple iOS (iPhone / iPad)";
      targetUrl = APP_STORE_URL;
      
      // Auto-redirect for iOS
      setTimeout(() => {
        window.location.href = targetUrl;
      }, 500);
    } 
    // 2. Check Android
    else if (/android/i.test(userAgent)) {
      detectedType = "android";
      detectedName = "Android Device";
      targetUrl = PLAY_STORE_URL;

      // Auto-redirect for Android Play Store
      setTimeout(() => {
        window.location.href = targetUrl;
      }, 500);
    } 
    // 3. Desktop / PC
    else {
      detectedType = "desktop";
      detectedName = "PC / Desktop Computer";
      targetUrl = "/";
    }

    setDeviceInfo({
      type: detectedType,
      name: detectedName,
      targetUrl: targetUrl
    });
  }, []);

  return (
    <div className="min-h-screen bg-slate-900 text-white flex flex-col items-center justify-center p-6 text-center">
      <div className="max-w-md w-full bg-slate-800/90 border border-slate-700/80 rounded-3xl p-8 shadow-2xl backdrop-blur-md">
        
        {/* Logo / Header */}
        <div className="w-16 h-16 bg-red-600 rounded-2xl flex items-center justify-center mx-auto mb-5 shadow-lg shadow-red-600/30">
          <Smartphone size={32} className="text-white" />
        </div>

        <h1 className="text-2xl font-black text-white tracking-tight mb-2">
          Medrph Labs
        </h1>
        <p className="text-xs text-slate-400 font-medium mb-6">
          Redirecting you to the best experience for your device...
        </p>

        {/* Device Detected Card */}
        <div className="bg-slate-900/80 border border-slate-700/50 rounded-2xl p-4 mb-6 text-left flex items-center gap-3.5">
          {deviceInfo.type === "ios" ? (
            <div className="w-10 h-10 rounded-xl bg-slate-800 border border-slate-700 flex items-center justify-center shrink-0">
              <Apple size={22} className="text-white" />
            </div>
          ) : deviceInfo.type === "android" ? (
            <div className="w-10 h-10 rounded-xl bg-emerald-500/20 border border-emerald-500/30 flex items-center justify-center shrink-0">
              <Smartphone size={22} className="text-emerald-400" />
            </div>
          ) : (
            <div className="w-10 h-10 rounded-xl bg-blue-500/20 border border-blue-500/30 flex items-center justify-center shrink-0">
              <Monitor size={22} className="text-blue-400" />
            </div>
          )}

          <div>
            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block">
              Detected Platform
            </span>
            <span className="text-sm font-bold text-white">
              {deviceInfo.name}
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          {deviceInfo.type === "android" && (
            <a
              href={PLAY_STORE_URL}
              className="w-full flex items-center justify-center gap-2.5 py-3.5 px-5 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-500 hover:to-red-600 text-white rounded-xl font-bold text-sm shadow-lg transition-all"
            >
              <Download size={18} />
              Open Google Play Store
            </a>
          )}

          {deviceInfo.type === "ios" && (
            <a
              href={APP_STORE_URL}
              className="w-full flex items-center justify-center gap-2.5 py-3.5 px-5 bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-600 hover:to-slate-700 text-white rounded-xl font-bold text-sm shadow-lg border border-slate-600 transition-all"
            >
              <Apple size={18} />
              Open Apple App Store
            </a>
          )}

          {deviceInfo.type === "desktop" && (
            <a
              href="/"
              className="w-full flex items-center justify-center gap-2.5 py-3.5 px-5 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-500 hover:to-red-600 text-white rounded-xl font-bold text-sm shadow-lg transition-all"
            >
              Continue on Web Browser
              <ArrowRight size={18} />
            </a>
          )}
        </div>

        {/* Footer info */}
        <div className="mt-6 pt-5 border-t border-slate-700/60 text-center">
          <p className="text-[11px] text-slate-500">
            If you are not redirected automatically, tap the button above.
          </p>
        </div>

      </div>
    </div>
  );
}
